/*
 * "Go to" — the in-app pages search can jump to. Mirrors the destinations in
 * layout/menu-items.jsx; `visible(access)` is the nav's own gate (see
 * access.js), so a page hidden from the nav never shows here either.
 * `keywords` are extra words that should find the page ("rfq" → Quotes).
 */
export const DESTINATIONS = [{
  label: 'Dashboard',
  path: '/',
  keywords: 'home overview',
  visible: () => true
},
// Sales
{
  label: 'Sales',
  path: '/Sales',
  keywords: 'cockpit executive scorecards',
  visible: a => a.sales && a.cockpit
}, {
  label: 'Territory & Reps',
  path: '/Territory',
  keywords: 'territory reps sales reps regions',
  visible: a => a.sales && a.territory
}, {
  label: 'Quotes',
  path: '/Quotes',
  keywords: 'quote order desk orders',
  visible: a => a.sales && a.quotes
}, {
  label: 'Stores',
  path: '/Stores',
  keywords: 'store locations retail',
  visible: a => a.sales && a.stores
}, {
  label: 'Forecasts',
  path: '/Forecast/Similarity',
  keywords: 'forecast similarity demand',
  visible: a => a.sales
},
// Products
{
  label: 'Product Explorer',
  path: '/Products',
  keywords: 'products catalog families configurations',
  visible: () => true
},
// Marketing
{
  label: 'Autopilot',
  path: '/Autopilot',
  keywords: 'ai recommendations',
  visible: a => a.marketing && a.autopilot
}, {
  label: 'Market Intelligence',
  path: '/MarketIntelligence',
  keywords: 'markets mi',
  visible: a => a.marketing
}, {
  label: 'Website Analytics',
  path: '/SiteActivity',
  keywords: 'web activity site traffic visitors pages',
  visible: a => a.marketing
}, {
  label: 'Campaigns',
  path: '/Campaigns',
  keywords: 'ads advertising flights',
  visible: a => a.marketing && a.campaigns
}, {
  label: 'Email',
  path: '/Email/campaigns',
  keywords: 'email campaigns journeys automations newsletter',
  visible: a => a.marketing && a.email
}, {
  label: 'Social',
  path: '/Social',
  keywords: 'social media facebook instagram',
  visible: a => a.marketing && a.social
}, {
  label: 'Content Hub',
  path: '/Content',
  keywords: 'content images video stories',
  visible: a => a.marketing && a.contentHub
},
// Customers
{
  label: 'Contacts',
  path: '/Contacts',
  keywords: 'people leads prospects',
  visible: a => a.contacts
}, {
  label: a => a.accountsLabel || 'Customers',
  path: '/Customers',
  keywords: 'customers accounts dealers',
  visible: a => a.customers
}, {
  label: 'Lifecycle',
  path: '/Lifecycle',
  keywords: 'funnel stages',
  visible: a => a.customers
}, {
  label: 'Audiences',
  path: '/Audiences/this_month',
  keywords: 'lists segments',
  visible: a => a.contacts
},
// Top-level entries
{
  label: 'Reports',
  path: '/Reports',
  keywords: 'custom reports',
  visible: a => a.reports
}, {
  label: 'Apps',
  path: '/Apps',
  keywords: 'research keywords seo',
  visible: () => true
}, {
  label: 'Manage Data',
  path: '/Data',
  keywords: 'data feeds uploads imports',
  visible: () => true
}, {
  label: 'Settings',
  path: '/Settings',
  keywords: 'brand templates activity log',
  visible: () => true
}];

// Pages for this member where the term starts the label or one of its words
// (or a keyword) — "rep" finds Territory & Reps, "ter" doesn't find Content.
export function matchDestinations(term, access) {
  const t = String(term || '').trim().toLowerCase();
  if (!t) return [];
  const words = v => v.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  return DESTINATIONS.filter(d => d.visible(access || {})).map(d => ({
    label: typeof d.label === 'function' ? d.label(access || {}) : d.label,
    path: d.path,
    keywords: d.keywords
  })).filter(d => d.label.toLowerCase().startsWith(t) || words(`${d.label} ${d.keywords}`).some(w => w.startsWith(t)));
}
export default DESTINATIONS;